<template>
  <div class="notification">
    <v-alert 
      tile
      dense
      height="30"
      max-height="30"
      :value="true"
      v-for="(item, i) in [notifications, others]"
      v-if="Object.keys(item).length"
      :key="item"
      :color="item.type"
    >
      {{ item.text }}
      <span class="font-weight-regular text-decoration-underline" v-if="item.reason">{{ item.reason }}</span>
      <span 
        class="blue--text text--darken-3 text-decoration-underline pointer ml-2" 
        @click="item.action"
        v-if="item.action"
      >
        {{ item.actionText }}
      </span>
    </v-alert>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      others: {}
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('user', ['bans']),
    ...mapGetters('user', ['isLogin', 'verifying']),
    notifications() {
      if(this.isLogin && !this.$route.matched.some(record => record.meta.requiresAuth)) {
        // if(!this.user.email_verified) {
        //   return [{type: 'warning', text: '請先進行Email驗證，以開通完整功能', actionText: '進行驗證', action: () => this.$router.push('/profile')}]
        // }
        if(!this.user.tel_verified) {
          return {type: 'warning', text: '請先進行手機驗證，以開通完整功能', actionText: '進行驗證', action: () => this.$router.push('/profile')}
        }
        else if(!this.user.identity_verified && !this.user.member_identity) {
          return {type: 'warning', text: '請先進行身分驗證，以開通完整功能', actionText: '進行驗證', action: () => this.$root.$emit('authentication')}
        }
        else if(this.verifying) {
          return {type: 'warning', text: '身分驗證資料正在審核中', actionText: '查看更多', action: () => this.$root.$emit('authentication')}
        }
        else if(!this.user.identity_verified && this.user.member_identity.denied) {
          return {type: 'warning', text: '身分驗證請求被拒絕，原因：', reason: this.user.member_identity.reason, actionText: '重新驗證', action: () => this.$root.$emit('authentication')}
        }
        else if(this.user.identity_verified && localStorage.getItem('unverified')) {
          localStorage.removeItem('unverified')
          this.others = {type: 'success', text: '您己通過身分驗證'}
          return {}
        }
        else if(this.user.disabled == 1 || this.user.disabled === true) {
          this.others = {type: 'error', text: '您的帳戶已被停用，原因：', reason: this.bans.length > 0 ? this.bans[0].reason : '未知'}
        }
      }
      return {}
    },
  },
  watch: {
    notifications() {
      this.$store.dispatch('user/setHaveNotification', Object.keys(this.notifications).length !== 0 || Object.keys(this.others).length !== 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  position: relative;
  width: 100%;
  .v-alert {
    padding: 0 20px;
    margin: 0;
    .v-alert__wrapper {
      height: 100%;
    }
    .v-alert__content {
      text-align: center;
      color: white;
      font-size: 12px;
      letter-spacing: 1px;
    }
  }
}
</style>